import React, { useEffect, useState } from "react";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import "./style.css";
import BarMenu from "./BarMenu";
import { AssortGroup } from "../../models/AssortGroup";
import FoodList from "./FoodList";
import { AssortGroupList } from "../../models/testData/AssortGroupList";
import useBasketManager from "../SaleMovie/CinemaHall/hooks/useBasketManager";

const SaleFood: React.FC = () => {
  const isDesktop = useDesktopSize();
  const [activeAssortGroup, setActiveAssortGroup] = useState<AssortGroup>(AssortGroupList[0]);

  const { getFoodList, handleAddBasket, foods } = useBasketManager();

  useEffect(() => {
    getFoodList(activeAssortGroup);
  }, [, activeAssortGroup]);

  return (
    <div className={isDesktop ? "food-panel" : "food-panel-mobile"}>
      <div className={"advertisement"}>
        <img src={"https://panel.eaktywni.pl/img/kinoTesty/food/rek_4.jpg"} alt={"reklama"} />
      </div>
      <BarMenu activeGroup={activeAssortGroup} setActiveGroup={setActiveAssortGroup} />
      <FoodList foodList={foods} activeGroup={activeAssortGroup} handleAddBasket={handleAddBasket} />
    </div>
  );
};

export default SaleFood;
